"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
interface CheckboxProps extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> {
  size?: "sm" | "md" | "lg";
}
const sizeClasses = {
  sm: {
    root: "w-3.5 h-3.5 border",
    icon: "h-2.5 w-2.5"
  },
  md: {
    root: "w-6 h-6 border-2",
    icon: "h-4 w-4"
  },
  lg: {
    root: "w-8 h-8 border-2",
    icon: "h-5 w-5"
  }
};
const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(({
  className,
  size = "md",
  ...props
}, ref) => <CheckboxPrimitive.Root ref={ref} className={cn("border-primary rounded-[4px] peer shrink-0 shadow-sm focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", sizeClasses[size].root, className)} {...props}>
    <CheckboxPrimitive.Indicator className={cn("flex items-center justify-center text-current")}>
      <Check className={sizeClasses[size].icon} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>);
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };